module.exports = __webpack_public_path__ + "img/Pasargad.7053d910.svg";